import { Command } from "commander";
import {
  writeFileSync,
  readFileSync,
  mkdirSync,
  existsSync,
  readdirSync,
} from "node:fs";
import { resolve, dirname } from "node:path";
import { fileURLToPath } from "node:url";
import chalk from "chalk";
import { fatalError } from "../ux/errors.js";

export const installPluginCommand = new Command("install-plugin")
  .description(
    "Install Fathom plugin for Claude Code (copies skills + MCP config)",
  )
  .option("--project-dir <dir>", "Target project directory", ".")
  .action((options: { projectDir: string }) => {
    const projectDir = resolve(options.projectDir);
    const __dirname = dirname(fileURLToPath(import.meta.url));
    // Try npm-installed path first (plugins copied by tsup), then monorepo dev path
    let pluginSource = resolve(__dirname, "../plugins/fathom");
    if (!existsSync(pluginSource)) {
      pluginSource = resolve(__dirname, "../../plugins/fathom");
    }

    if (!existsSync(pluginSource)) {
      fatalError(
        "Plugin source files not found",
        `Expected at ${pluginSource}`,
        "Ensure fathom-cli >= 0.3.3 is installed",
      );
    }

    console.log(chalk.bold("\nFathom — Install Plugin"));
    console.log(chalk.dim("\u2500".repeat(50)));

    // 1. Copy skills
    const skillsSource = resolve(pluginSource, "skills");
    if (existsSync(skillsSource)) {
      const skillDirs = readdirSync(skillsSource, { withFileTypes: true })
        .filter((d) => d.isDirectory())
        .map((d) => d.name);

      for (const skillDir of skillDirs) {
        const src = resolve(skillsSource, skillDir, "SKILL.md");
        if (!existsSync(src)) continue;
        const destDir = resolve(
          projectDir,
          ".claude",
          "skills",
          "fathom",
          skillDir,
        );
        mkdirSync(destDir, { recursive: true });
        writeFileSync(resolve(destDir, "SKILL.md"), readFileSync(src, "utf-8"));
        console.log(chalk.green(`  \u2713 .claude/skills/fathom/${skillDir}/SKILL.md`));
      }
    }

    // 2. Copy plugin.json
    const pluginJsonSrc = resolve(
      pluginSource,
      ".claude-plugin",
      "plugin.json",
    );
    if (existsSync(pluginJsonSrc)) {
      const destDir = resolve(projectDir, ".claude-plugin");
      mkdirSync(destDir, { recursive: true });
      writeFileSync(
        resolve(destDir, "plugin.json"),
        readFileSync(pluginJsonSrc, "utf-8"),
      );
      console.log(chalk.green("  \u2713 .claude-plugin/plugin.json"));
    }

    // 3. Merge .mcp.json
    const mcpPath = resolve(projectDir, ".mcp.json");
    let mcpConfig: Record<string, unknown> = { mcpServers: {} };
    if (existsSync(mcpPath)) {
      try {
        mcpConfig = JSON.parse(readFileSync(mcpPath, "utf-8"));
        if (!mcpConfig.mcpServers) mcpConfig.mcpServers = {};
      } catch {
        mcpConfig = { mcpServers: {} };
      }
    }
    (mcpConfig.mcpServers as Record<string, unknown>).fathom = {
      command: "npx",
      args: ["-y", "fathom-token-mcp@latest", "--project-dir", "."],
    };
    writeFileSync(mcpPath, JSON.stringify(mcpConfig, null, 2) + "\n");
    console.log(chalk.green("  \u2713 .mcp.json (MCP auto-discovery)"));

    console.log(chalk.bold("\n\u2713 Fathom plugin installed"));
    console.log(
      chalk.dim("  Skills and MCP config are ready for Claude Code\n"),
    );
  });
